import { ThemeEvents } from '@theme/events';

class ProductTrustRow extends HTMLElement {
  connectedCallback() {
    document.addEventListener(ThemeEvents.variantUpdate, this.#onVariantUpdate);
  }

  disconnectedCallback() {
    document.removeEventListener(ThemeEvents.variantUpdate, this.#onVariantUpdate);
  }

  #onVariantUpdate = (event) => {
    const resource = event.detail?.resource;
    if (!resource) return;

    const stockEl = this.querySelector('[data-role="stock"]');
    const deliveryEl = this.querySelector('[data-role="delivery"]');
    if (!stockEl || !deliveryEl) return;

    const available = Boolean(resource.available);
    stockEl.textContent = available
      ? this.dataset.inStockLabel
      : this.dataset.oosLabel;
    deliveryEl.textContent = available
      ? this.dataset.inStockDelivery
      : this.dataset.oosDelivery;
  };
}

if (!customElements.get('product-trust-row')) {
  customElements.define('product-trust-row', ProductTrustRow);
}
